import React, {useEffect, useRef} from "react";
import isMobile from "ismobilejs";

import gsap from "gsap";
import c3 from "c3";
import * as d3 from "d3";

import {chartsDonut, donutData} from "./global.json";

import styles from "./Donuts.module.scss"

export default function Donuts() {
    const transformRef = useRef({});
    const donutPosRef = useRef({});

    useEffect(() => {
        const charts = document.querySelectorAll('.chart')

        setTimeout(() => {

            Object.values(charts).map((chart, index) => {
                const chartData = chartsDonut;

                chartData.bindto = `#${chart.id}`;
                chartData.donut.title = donutData[index].title;
                chartData.data.columns = donutData[index].data;
                chartData.color.pattern = donutData[index].color;

                chartData.onrendered = function () {
                    const figures = d3.selectAll(`#${chart.id} .c3-chart-arc text`);

                    Object.values(figures._groups[0]).map((item, index) => {
                        d3.select(item).remove();

                        return true;
                    });
                };

                chartData.donut.label.format = function (d, v, i) {
                    return Math.round(v * 100) + '%'
                };

                if (isMobile().phone) {
                    chartData.donut.width = 29;

                } else if (window.innerWidth > 2000) {
                    chartData.donut.width = 50;
                    chartData.size.width = 500;
                    chartData.size.height = 500;
                }

                c3.generate(chartData);


                return true;
            })
        }, 1000);
    }, []);

    const svg1 = `
<svg width="363px" height="397px" viewBox="0 0 363 397" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Cercle-1" transform="translate(-25.000000, -7.000000)">
            <path d="M189.83457,107.543201 L185.149802,71.2796222 L185.721116,71.2796222 C192.050788,70.4756923 198.422628,70.0483992 204.802975,70 L204.802975,106.560634 C199.890145,106.565413 194.982451,106.878316 190.108801,107.4975 L189.83457,107.543201 Z" id="Path" fill="#F4706E" fill-rule="nonzero"></path>
            <path d="M182.384647,343.33644 L182.041859,343.33644 C125.061552,332.13147 84.3866973,281.587316 85.6324165,223.534324 C86.8781356,165.481333 129.683743,116.728195 187.092267,107.977359 L181.607661,71.7366301 C106.617653,83.1345329 50.6833274,146.796914 49.0372228,222.6234 C47.3911183,298.449885 100.509988,364.479242 174.934723,379.12016 L175.483184,379.234412 L182.384647,343.33644 Z" id="Path" fill="#FEA1A0" fill-rule="nonzero"></path>
            <path d="M313.832379,337.852345 C343.087313,309.511654 360.028024,270.807707 360.999994,230.089876 C360.999994,228.696002 360.999994,227.324978 360.999994,225.976805 C361.017007,141.410474 293.644064,72.2296658 209.09925,70 L208.482232,70 L207.728099,106.560634 L208.116592,106.560634 C272.842167,108.256859 324.44197,161.189349 324.481656,225.931104 C324.481656,226.982222 324.481656,228.03334 324.481656,229.084459 C322.762215,295.038369 267.906955,347.116343 201.946409,345.415826 C196.247925,345.258429 190.567053,344.708718 184.94413,343.770597 L178.7968,379.851373 C186.125136,381.094754 193.53301,381.812564 200.963751,381.99931 C202.334902,381.99931 203.706054,381.99931 205.077205,381.99931 C245.710559,382.085084 284.757302,366.234847 313.832379,337.852345 L313.832379,337.852345 Z" id="Path" fill="#FED1CC" fill-rule="nonzero"></path>
            <text id="Femme-46%" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="20" font-weight="normal" line-spacing="24" fill="#FFFFFF">
                <tspan x="24.3" y="373">Femme</tspan>
                <tspan x="37.74" y="397" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-weight="bold">46%</tspan>
            </text>
            <text id="Autre-2%" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="20" font-weight="normal" line-spacing="24" fill="#FFFFFF">
                <tspan x="171.16" y="15">Autre</tspan>
                <tspan x="181.3" y="39" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-weight="bold">2%</tspan>
            </text>
            <text id="Homme-52%" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="20" font-weight="normal" line-spacing="24" fill="#FFFFFF">
                <tspan x="321.29" y="373">Homme</tspan>
                <tspan x="335.74" y="397" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-weight="bold">52%</tspan>
            </text>
            <text id="Genre" font-family="DINNextLTPro-Medium, DIN Next LT Pro" font-size="28" font-weight="400" line-spacing="24" fill="#FFFFFF">
                <tspan x="163.476" y="228.24">Genre</tspan>
            </text>
        </g>
    </g>
</svg>`;

    const svg2 = `
<svg width="354px" height="413px" viewBox="0 0 354 413" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Cercle-2" transform="translate(-2.000000, -7.000000)">
            <path d="M85.7202711,166 L51,154.875749 L51,154.511765 C71.672225,90.384078 131.493108,46.9283793 199,47 L199,83.3984557 C147.367865,83.3957523 101.638801,116.654647 85.8342575,165.704263 L85.7202711,166 Z" id="Path" fill="#FEA1A0" fill-rule="nonzero"></path>
            <path d="M200.068541,359 C198.697715,359 197.326889,359 195.956063,359 C111.413202,356.819921 44.0090552,287.66758 44,203.102804 C44,201.732079 44,200.361353 44,198.990628 C44.3841049,185.423533 46.5189271,171.962852 50.3514938,158.942594 L85.4217926,169.291572 C82.4807712,179.249902 80.8449598,189.547848 80.5553603,199.92729 C80.5553603,200.97818 80.5553603,202.029069 80.5553603,203.102804 C80.7063026,268.36955 133.225107,321.428937 198.491604,322.25298 C263.758101,323.077023 317.59998,271.360527 319.398946,206.118401 C319.398946,205.067511 319.398946,204.016622 319.398946,202.965732 C319.397061,138.228717 267.826083,85.2735566 203.107206,83.5526836 L202.718805,83.5526836 L203.472759,47 L204.089631,47 C288.60569,49.204168 355.979206,118.335743 356,202.87435 C356,204.22223 356,205.592956 356,206.986527 C353.80783,291.505363 284.66768,358.887502 200.114236,358.908618 L200.068541,359 Z" id="Path" fill="#FED1CC" fill-rule="nonzero"></path>
            <text id="Experience" font-family="DINNextLTPro-Medium, DIN Next LT Pro" font-size="28" font-weight="400" line-spacing="24" fill="#FFFFFF">
                <tspan x="133.158" y="205.24">Experience</tspan>
            </text>
            <text id="Played-1-4-years-21%" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="20" font-weight="normal" line-spacing="24" fill="#FFFFFF">
                <tspan x="1.33" y="15">Played 1-4 years</tspan>
                <tspan x="54.74" y="39" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-weight="bold">21%</tspan>
            </text>
            <text id="Played-5+-years-79%" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="20" font-weight="normal" line-spacing="24" fill="#FFFFFF">
                <tspan x="211.13" y="389">Played 5+ years</tspan>
                <tspan x="260.74" y="413" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-weight="bold">79%</tspan>
            </text>
        </g>
    </g>
</svg>`
    return (
        <div className={styles.Main}>
            <div className={styles.ChartWrapper}>
                {
                    donutData[0].data.map(array =>
                        <div className={styles.Caret} key={array[0]}>
                            {array[0]}
                            <br/>
                            <strong>
                                {array[1]}%
                            </strong>
                        </div>
                    )
                }

                <div className={'chart'} id={'Donut1'}/>
            </div>
            <div className={styles.ChartWrapper}>
                {
                    donutData[1].data.map(array =>
                        <div className={styles.Caret} key={array[0]}>
                            {array[0]}
                            <br/>
                            <strong>
                                {array[1]}%
                            </strong>
                        </div>
                    )
                }

                <div className={'chart'} id={'Donut2'}/>
            </div>
        </div>
    )
}
